import axios from "axios";
import Config from "src/config";

const v2_actionDeletarCredencias = (id, data) => {
    return axios({
        method: "delete",
        url: `${Config.dev ? Config.url_dev : Config.url_prod}/api/v2/credenciais/${id}/deletar`
    });
};

export default v2_actionDeletarCredencias;
